import React, { useEffect } from 'react';
import PortfolioNav from './portfolio/PortfolioNav';
import PortfolioFooter from './portfolio/PortfolioFooter';
import HeroSection from './sections/HeroSection';
import AboutSection from './sections/AboutSection';
import SkillsSection from './sections/SkillsSection';
import ResumeSection from './sections/ResumeSection';
import RecommendationsSection from './sections/RecommendationsSection';
import ContactSection from './sections/ContactSection';
import DiligenceSection from './sections/DiligenceSections';

const SinglePagePortfolio = () => {
  useEffect(() => {
    const nav = document.getElementById('nav');
    const handleScroll = () => {
      nav?.classList.toggle('scrolled', window.scrollY > 40);
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1 }
    );

    const revealElements = document.querySelectorAll('.reveal');
    revealElements.forEach((element) => observer.observe(element));

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
      observer.disconnect();
    };
  }, []);

  return (
    <>
      <PortfolioNav />
      <HeroSection />
      <AboutSection />
      <SkillsSection />
      <ResumeSection />
      <RecommendationsSection />
      <ContactSection />
      <DiligenceSection />
      <PortfolioFooter />
    </>
  );
};

export default SinglePagePortfolio;

